import { useLayoutEffect, useState } from "react";
import GuestCheckoutFormModal, {
  type GuestCheckoutFormData,
} from "~/features/cart/B2CCart/components/GuestCheckoutDialog/components/GuestCheckoutFormModal";
import { GuestCheckoutLoginModal } from "~/features/cart/B2CCart/components/GuestCheckoutDialog/components/GuestCheckoutLoginModal";
import ResetPasswordPopup from "~/features/auth/login/components/ResetPasswordPopup";
import { CART_STEP_3 } from "~/utils/url/staticUrls";
import { useDispatch } from "react-redux";
import { openAuthOverlay } from "~/features/registration/components/redux/AuthActions";

export type GuestCheckoutModalProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: (formData: GuestCheckoutFormData) => void;
};

const Page = {
  Main: "main",
  Form: "form",
  ResetPassword: "resetPassword",
} as const;

export const GuestCheckoutModal = ({ open, onClose, onSubmit }: GuestCheckoutModalProps) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState<(typeof Page)[keyof typeof Page]>(Page.Main);
  const [email, setEmail] = useState<string>("");

  useLayoutEffect(() => {
    if (open) {
      setPage(Page.Main);
    }
  }, [open]);

  return (
    <>
      <GuestCheckoutLoginModal
        open={open && page === Page.Main}
        onClose={onClose}
        onContinueAsGuest={() => setPage(Page.Form)}
        onResetPassword={(email) => {
          setEmail(email);
          setPage(Page.ResetPassword);
        }}
      />
      {open && page === Page.ResetPassword && <ResetPasswordPopup close={onClose} initialEmail={email} />}
      <GuestCheckoutFormModal
        open={open && page === Page.Form}
        onClose={onClose}
        onSubmit={onSubmit}
        onLoginClick={(email: string) => {
          setEmail(email);
          dispatch(
            openAuthOverlay("login", {
              initialEmail: email,
              alternativeLoginRedirectUrl: CART_STEP_3,
            }),
          );
        }}
      />
    </>
  );
};
